<template>
  <div class="layout-topbar clearfix" style="background: white !important;">
    <button class="layout-menu-button p-link"
            style="color: #1c355e !important"
            @click="onMenuButtonClick"
            v-tooltip.bottom="$toolips.standard($t('appTopBar.menu'))">
      <i class="pi pi-bars"></i>
    </button>

    <div v-if="$vssWidth < 900" style="float: left; padding-top:.5em"><TopBarLatitudini/></div>
    <div v-if="$vssWidth > 636" class="grid" style="float: left; padding-top:1.25em; margin-left:1em">
      <div><h3 style="color:#03365F">{{$t('appTopBar.welcome')}}</h3></div>
      <div style="margin-left: .5em;"><h3 style="color: #61B57C">{{ user ? user.description : '' }}</h3></div>
    </div>

    <button id="topbar-menu-button" class="p-link" style="color: #1c355e !important" @click="onTopbarMenuButtonClick">
      <i class="pi pi-ellipsis-v"></i>
    </button>
    <ul :class="topbarItemsClass">
      <li role="menuitem">
        <button class="layout-menu-button p-link"
                style="margin-top:-.5em; color: #1c355e !important"
                @click="doLogout"
                v-tooltip.bottom="$toolips.standard($t('appTopBar.logout'))">
          <i class="pi pi-sign-out"></i>
        </button>
      </li>
      <li v-if="profileMode === 'popup' || horizontal"
          :class="['user-profile', {'active-topmenuitem': activeTopbarItem === 'profile'}]"
          @click="$emit('topbar-item-click',{originalEvent:$event,item:'profile'})">
        <button class="layout-menu-button p-link"
                style="margin-top:-.5em; color: #1c355e !important"
                v-tooltip.bottom="$toolips.standard($t('appTopBar.profiles'))">
          <i class="pi pi-user"></i>
        </button>

        <transition name="layout-submenu-container">
          <ul class="fadeInDown" v-show="activeTopbarItem === 'profile'">
            <li role="menuitem" v-for="profile in profiles" :key="profile">
              <button class="p-link" @click="this.setProfile(profile)">
                <i class="pi pi-user"></i>
                <i v-if="profile === user.profile" class="pi pi-angle-right"></i>
                <span :style="profile === user.profile ? 'text-decoration: underline;' : 'margin-left: 1.5em;'">
                  {{ profile.description }}</span>
              </button>
            </li>
          </ul>
        </transition>
      </li>
      <li>
        <TopBarLatitudini v-if="$vssWidth > 900"/>
      </li>
    </ul>
  </div>
</template>

<script>
import {useAclStore} from "@/store/aclStore";
import {useApplicationStore} from "@/store/applicationStore";
import {useEndpointStore} from "@/store/endpointStore";
import {useLoadingStore} from "@/store/loadingStore";
import {useUserStore} from "@/store/userStore";
import TopBarLatitudini from "@/components/Latitudes/TopBarLatitudini";
import {VueScreenSizeMixin} from "vue-screen-size";
import jwt_decode from "jwt-decode";
import SsoService from "@/service/SsoService";

export default {
  mixins: [VueScreenSizeMixin],
  props: {
    topbarMenuActive: Boolean,
    activeTopbarItem: String,
    profileMode: String,
    horizontal: Boolean
  },
  components: {
    'TopBarLatitudini': TopBarLatitudini,
  },
  setup() {
    const aclStore = useAclStore()
    const applicationStore = useApplicationStore()
    const endpointStore = useEndpointStore()
    const loadingStore = useLoadingStore()
    const userStore = useUserStore()

    return {
      aclStore,
      applicationStore,
      endpointStore,
      loadingStore,
      userStore,
    }
  },
  data(){
    return{
      silentRefresh: null,
    }
  },
  beforeMount() {
    this.ssoService = new SsoService();
    if (this.token) {
      this.refreshJwt(jwt_decode(this.token).exp);
    }
  },
  computed: {
    user() {
      return this.userStore.user
    },
    token() {
      return this.userStore.user.token
    },
    profile() {
      return this.userStore.profile
    },
    profiles() {
      return this.userStore.user.profiles
    },
    topbarItemsClass() {
      return ['topbar-menu fadeInDown', {
        'topbar-menu-visible': this.topbarMenuActive
      }];
    }
  },
  methods: {
    refreshJwt(expire) {
      if (this.user == null && this.silentRefresh != null) {
        clearInterval(this.silentRefresh);
      } else {
        this.silentRefresh = setTimeout(() => {
          this.ssoService.refreshJwt(this.user.refresh).then(token => {
            this.userStore.setToken(token);
          }).catch(e => {
            console.log("token expired", e);
            this.doLogout();
          });
        }, Math.floor(expire * 1000 - Date.now() - 5000)); //5 secs grace period
      }
    },
    setProfile(profile) {
      this.userStore.setProfile(profile, this)
      this.$router.push('/')
    },
    onMenuButtonClick(event) {
      this.$emit('menubutton-click', event);
    },
    onTopbarMenuButtonClick(event) {
      this.$emit('topbar-menubutton-click', event);
    },
    goDashboard() {
      window.location = "/#/"
    },
    doLogout() {
      this.aclStore.$reset()
      this.applicationStore.$reset()
      this.endpointStore.$reset()
      this.loadingStore.$reset()
      this.userStore.$reset()
      this.$router.push({path: '/login'});
    },
  }
}
</script>
